import React from 'react';
import PropTypes from 'prop-types';
import { useUiComponentsInternationalContext } from '@repo/static-translations';
import BlockContent from './sanity/BlockContent';

function ProductAttributes({ productAttributes }) {
  const {
    specialFeatures,
    moreInformation,
    range,
    stimulationRanges,
    barkDetectionType,
    automaticShutoff,
    expandableSystem,
    remoteTransmitter,
    waterproof,
    beeperOptions,
    dogSize,
    beeper,
    batteries,
    lowBatteryIndicator,
    productLength,
    systemCompatibility,
    contents,
    productDimensions,
  } = productAttributes;

  const { tt } = useUiComponentsInternationalContext();

  return (
    <>
      {specialFeatures && specialFeatures[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.specialFeaturesHeader)}</h2>
          <BlockContent blocks={specialFeatures} />
        </>
      )}

      {moreInformation && moreInformation[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.moreInformationHeader)}</h2>
          <BlockContent blocks={moreInformation} />
        </>
      )}

      {range && range[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.rangeHeader)}</h2>
          <BlockContent blocks={range} />
        </>
      )}

      {stimulationRanges && stimulationRanges[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.stimulationRangesHeader)}
          </h2>
          <BlockContent blocks={stimulationRanges} />
        </>
      )}

      {barkDetectionType && barkDetectionType[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.barkDetectionTypeHeader)}
          </h2>
          <BlockContent blocks={barkDetectionType} />
        </>
      )}

      {automaticShutoff && automaticShutoff[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.automaticShutoffHeader)}
          </h2>
          <BlockContent blocks={automaticShutoff} />
        </>
      )}

      {expandableSystem && expandableSystem[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.expandableSystemHeader)}
          </h2>
          <BlockContent blocks={expandableSystem} />
        </>
      )}

      {remoteTransmitter && remoteTransmitter[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.remoteTransmitterHeader)}
          </h2>
          <BlockContent blocks={remoteTransmitter} />
        </>
      )}

      {waterproof && waterproof[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.waterproofHeader)}</h2>
          <BlockContent blocks={waterproof} />
        </>
      )}

      {beeperOptions && beeperOptions[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.beeperOptionsHeader)}</h2>
          <BlockContent blocks={beeperOptions} />
        </>
      )}

      {dogSize && dogSize[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.dogSizeHeader)}</h2>
          <BlockContent blocks={dogSize} />
        </>
      )}

      {beeper && beeper[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.beeperHeader)}</h2>
          <BlockContent blocks={beeper} />
        </>
      )}

      {batteries && batteries[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.batteriesHeader)}</h2>
          <BlockContent blocks={batteries} />
        </>
      )}

      {lowBatteryIndicator > 0 && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.lowBatteryIndicatorHeader)}
          </h2>
          <p>{tt(s => s.productAttributesComponent.yes)}</p>
        </>
      )}

      {productLength && productLength[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.productLengthHeader)}</h2>
          <BlockContent blocks={productLength} />
        </>
      )}

      {systemCompatibility && systemCompatibility[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.systemCompatibilityHeader)}
          </h2>
          <BlockContent blocks={systemCompatibility} />
        </>
      )}

      {contents && contents[0]?.children[0]?.text && (
        <>
          <h2>{tt(s => s.productAttributesComponent.contentsHeader)}</h2>
          <BlockContent blocks={contents} />
        </>
      )}

      {productDimensions && productDimensions[0]?.children[0]?.text && (
        <>
          <h2>
            {tt(s => s.productAttributesComponent.productDimensionsHeader)}
          </h2>
          <BlockContent blocks={productDimensions} />
        </>
      )}
    </>
  );
}

ProductAttributes.propTypes = {
  productAttributes: PropTypes.shape({
    specialFeatures: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    moreInformation: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    range: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    stimulationRanges: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    barkDetectionType: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    automaticShutoff: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    expandableSystem: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    remoteTransmitter: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    waterproof: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    beeperOptions: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    dogSize: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    beeper: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    batteries: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    lowBatteryIndicator: PropTypes.bool,
    productLength: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    systemCompatibility: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    contents: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
    productDimensions: PropTypes.arrayOf(
      PropTypes.shape({
        children: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
          })
        ),
      })
    ),
  }).isRequired,
};

export default ProductAttributes;
